import { buildExistingPlacements } from 'app/modules/wallforming/components/setting-container/connector-placement/utils/buildSolveConnectorPlacementRequest';

import type { SolveAnchorPlacementModel } from 'api/models';
import type { PlacementState } from 'app/modules/wallforming/components/state-management/placement/types';

interface BuildSolveAnchorPlacementRequestOptions {
    state: PlacementState;
    sessionId: string;
    systemId: string;
    poiIndex: number;
    selectedAnchorArticleGuid: string;
    targetSupportInstanceId?: string;
}

export function buildSolveAnchorPlacementRequest({
    state,
    sessionId,
    systemId,
    poiIndex,
    selectedAnchorArticleGuid,
    targetSupportInstanceId
}: BuildSolveAnchorPlacementRequestOptions): SolveAnchorPlacementModel {
    const poiId = state.pois[poiIndex]?.poi.poiGuid;
    if (!poiId) {
        throw new Error('The selected wall POI is not available.');
    }

    // The solver only evaluates instances on the target wall, so trim the payload to them.
    const existingPlacements = buildExistingPlacements(
        state,
        state.pois.map((_, index) => index),
        false
    ).placements.flatMap((group) => {
        const instances = group.instances.filter((instance) => instance.poiGuids?.includes(poiId));
        return instances.length > 0 ? [{ ...group, instances }] : [];
    });

    return {
        sessionId,
        poiId,
        systemId,
        selectedAnchorArticleGuid,
        ...(targetSupportInstanceId ? { targetSupportInstanceId } : {}),
        existingPlacements
    };
}
